//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JobEventBus } from "@/core/lib/job/job.lib";
export default {
  name: "one-off-schedule-header",
  props: {
    showCalendar: {
      type: Boolean,
      required: true
    },
    internal: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    updateShowCalendar: function updateShowCalendar() {
      JobEventBus.$emit("update:show-calendar");
    }
  }
};